import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect,Link } from 'react-router-dom'; 
import {Row,Form} from 'react-bootstrap';
import FileIcon, { defaultStyles } from 'react-file-icon';

import {LOGIN_CLIENT_GROUP} from '../../../configs/staticConfigs';
import {MSG_REQUIRED,MSG_FILE_FORMAT_ERROR,MSG_NOT_FOUND,MSG_NOTES_ADD_SUCCESS,MSG_NOTES_ADD_ERROR, MSG_NOTES_DOCUMENT_ADD_SUCCESS, MSG_NOTES_DOCUMENT_ADD_ERROR, MSG_NOTES_DOCUMENT_DELETE_SUCCESS, MSG_NOTES_DOCUMENT_DELETE_ERROR} from '../../../configs/msgConfigs';
import {LBL_CONFIRM_DELETE, LBL_CONFIRM_DELETE_DOCUMENT, LBL_CONFIRM_DELETE_NOTES_DOCUMENT, LBL_NOTES, LBL_POST, LBL_VIEW_MORE, LBL_ADD_CREW_NOTES} from '../../../configs/labelConfigs'; 

import ModalWindow from '../../commons/helpers/modalWindow';
import Toast from '../../commons/helpers/toast';

import * as types from '../../../actions';
import {crewNotesListAction,crewNotesAddAction,crewNotesDocumentAddAction,crewNotesDocumentDeleteAction} from '../../../actions/crewActions'; 

import {fileExtension} from '../../../utils/validation';
import {userGroupUrlCheck,getUserTimeZone} from '../../../utils/userGroupUrlCheck';
import {converDateToLocal} from '../../../utils/commonUtilities';

class CrewNotes extends Component {

    constructor(props){
        super()
        this.state = {
            loadCrewNotes:0,
            crewNotesList:[],
            crewNotes:'',
            crewNotesError:'',
            currentPage:1,
            pageSize:10, 
            totalPages:0,
            notesLoaded:false, 
            notesId:'',
            notesDocId:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
        }

        this.onHandleChange  = this.onHandleChange.bind(this);
        this.setToasterState = this.setToasterState.bind(this); 
        this.modalFileDelete = React.createRef(); 
        this.modalDelete     = React.createRef(); 
    }

   

    onModalFormReset = () =>{       
    }

    delNotesDocFile = (e,notesId,notesDocId) => {    
        e.preventDefault();     
        this.modalFileDelete.current.handleOpenModal();
        this.setState({
            notesId:notesId,
            notesDocId:notesDocId,
        });  
        
    }   

    deleteNotesDocFile = () => { 
        let data ={
            "crew_note_doc_id":this.state.notesDocId,
        }
        this.props.crewNotesDocumentDeleteAction(data);
        this.modalFileDelete.current.handleModelClose();                    
    }

    onHandleNotesChange = (e) =>{
        const {name,value}  = e.target;
        if(value.trim()==="") {
            this.setState({crewNotes:value}); // , crewNotesError:MSG_REQUIRED
        }
        else {
            this.setState({crewNotes:value, crewNotesError:''});
        }
    }

    onSaveCrewNotes = (e) =>{
        e.preventDefault(); 
        const {name,value}  = e.target;
        if(this.state.crewNotes.trim()==="") {
            this.setState({crewNotesError:MSG_REQUIRED}); 
            return false; 
        }
        else {
            this.setState({crewNotesError:''});
            this.props.crewNotesAddAction({'crew': this.props.crewId, 'user_by':this.props.associateId, 'affiliate': this.props.affiliateId, 'notes': this.state.crewNotes}); 
        }
    }

    onHandleChange = (e,notesId) =>{
        const {name,value}  = e.target;
        if(e.target.type=== "file"){ // document upload
            this.setState({
                notesId:notesId,
                notesDocId:'',
            });  
            let isFileValid = true;
            if(e.target.files.length>0){
                for (let x = 0; x < e.target.files.length; x++) {
                    if(!fileExtension(e.target.files[x].name)){
                        isFileValid = false;
                    }
                }
                if(isFileValid){
                    const data  = new FormData();
                    data.append('crew_note', Number(e.target.id)); 
                    data.append("file", e.target.files[0]);
                    // for (let x = 0; x < e.target.files.length; x++) {
                    //     data.append("file", e.target.files[x]);
                    // } 
                    this.props.crewNotesDocumentAddAction(data);
                }else{
                    this.setToasterState(true,MSG_FILE_FORMAT_ERROR,false); 
                }  
            }    

        }
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    } 

    setToasterState(isEnabled,message,isSucces,isAutoHide=true){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToast();
            }, 3000);
        }      
    }

    listCreNotes = () => {
        if(this.props.crewId){
            this.props.crewNotesListAction({crew_id:this.props.crewId,page:this.state.currentPage,
                pageSize:this.state.pageSize}); 
        }
    }
    
    loadNextPage = () => {
        let nextPage = this.state.currentPage+1; 
        this.setState({currentPage:nextPage}, () => {
            this.listCreNotes(); 
        });
    }

    componentDidMount() {
        // this.listCreNotes(); 
    }

    componentDidUpdate(prevProps) { 
        const { crewNotesList,crewNotesActivity,status,activity,errorData,totalPages,numRows,count,crewNotesNew,crewNotesDocNew,crewNotesResLinks} = this.props; 

        if(this.props.loadCrewNotes && this.props.loadCrewNotes > 0 && this.props.loadCrewNotes > this.state.loadCrewNotes) {
            this.setState({loadCrewNotes:this.props.loadCrewNotes,currentPage:1},() => {
                this.listCreNotes();
            })
        }

        if (crewNotesActivity !== prevProps.crewNotesActivity) {
            let arrTmp = crewNotesActivity.split('~~');
            if(arrTmp[0]===types.CREW_NOTES_LIST_SUCCESS) {
                let newNotesList = []; // 
                if(this.props.crewNotesResLinks && this.props.crewNotesResLinks.current_page && this.props.crewNotesResLinks.current_page > 1) {
                    newNotesList = [...this.state.crewNotesList,...crewNotesList];  
                    this.setState({crewNotesList:newNotesList,totalPages:totalPages,notesLoaded:true});
                }
                else {
                    newNotesList = [...crewNotesList]; 
                    this.setState({crewNotesList:newNotesList,totalPages:totalPages,notesLoaded:true,currentPage:1});
                } 
            } 
            else if(arrTmp[0]===types.CREW_NOTES_LIST_ERROR) {
                this.setState({crewNotesList:[],totalPages:0,currentPage:1});
            } 
            else if(arrTmp[0]===types.CREW_NOTES_ADD_SUCCESS) {
                this.setToasterState(true,MSG_NOTES_ADD_SUCCESS,true);
                this.setState({crewNotes:'',crewNotesList:[crewNotesNew,...this.state.crewNotesList]}); 
                // this.listCreNotes();
            }
            else if(arrTmp[0]===types.CREW_NOTES_ADD_ERROR) {
                this.setToasterState(true,MSG_NOTES_ADD_ERROR,false);
            }   
            else if(arrTmp[0]===types.CREW_NOTES_DOCUMENT_ADD_SUCCESS) {
                this.setToasterState(true,MSG_NOTES_DOCUMENT_ADD_SUCCESS,true);
                // ADD NEW FILE OBECT TO STATE NOTES ARRAY  
                let notesList = this.state.crewNotesList; 
                let newNotesList = []; 
                notesList.forEach(notesItem => {
                    if(notesItem.id===this.state.notesId) {
                        let docItems = [];
                        docItems = notesItem.crewnotedoc_set; 
                        notesItem.crewnotedoc_set = [...docItems,crewNotesDocNew]; 
                        newNotesList.push(notesItem); 
                    }
                    else {
                        newNotesList.push(notesItem); 
                    }
                });
                this.setState({crewNotesList:newNotesList,notesId:''}); 
            }
            else if(arrTmp[0]===types.CREW_NOTES_DOCUMENT_ADD_ERROR) {
                this.setToasterState(true,MSG_NOTES_DOCUMENT_ADD_ERROR,false);
            }
            else if(arrTmp[0]===types.CREW_NOTES_DOCUMENT_DELETE_SUCCESS) {
                this.setToasterState(true,MSG_NOTES_DOCUMENT_DELETE_SUCCESS,true);
                // REMOVE FILE ELEMENT FROM STATE NOTES ARRAY 
                let notesList = this.state.crewNotesList; 
                let newNotesList = []; 
                notesList.forEach(notesItem => {
                    if(notesItem.id===this.state.notesId) {
                        let docItems = [];
                        docItems = notesItem.crewnotedoc_set.filter(item => item.id!=this.state.notesDocId); 
                        notesItem.crewnotedoc_set = docItems; 
                        newNotesList.push(notesItem); 
                    }
                    else {
                        newNotesList.push(notesItem); 
                    }
                });
                this.setState({crewNotesList:newNotesList,notesId:'',notesDocId:''});
            }
            else if(arrTmp[0]===types.CREW_NOTES_DOCUMENT_DELETE_ERROR) {
                this.setToasterState(true,MSG_NOTES_DOCUMENT_DELETE_ERROR,false);
            }
        } 
    }
    
    render(){
        let timeZone =  getUserTimeZone(window.location);
        const {toastMessage,toastFlag,toastSuccess,crewNotesList,totalPages,currentPage,notesLoaded,crewNotesError} = this.state; 

        let isSuperAdmin = this.props.isSuperAdmin ? this.props.isSuperAdmin : false; 

        let userGroupData = userGroupUrlCheck(window.location);
        let userGroup = '';
        let isClientPage = false;
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        if(userGroup===LOGIN_CLIENT_GROUP){
            isClientPage = true;
        }

        return(
            <React.Fragment>
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="col-md-12">
                <Form autoComplete="off" className="document" encType="multipart/form-data"> 
                    <Form.Group className="col-md-12">
                        <Row>
                            <div className='col-md-12 padding-Bottom-5 margin-top-10 padding-left-0'>
                                <div className="input-input col-md-12 padding-Bottom-5 float-right padding-left-0"><textarea name="text-crew-notes" onChange={(e) => this.onHandleNotesChange(e)} value={this.state.crewNotes || ''}  className={crewNotesError===''?"form-control ":"form-control  input-error"} placeholder={LBL_ADD_CREW_NOTES} ></textarea></div>
                            </div>
                            <div className="col-md-12 padding-right-30">
                                <button onClick={(e) => this.onSaveCrewNotes(e)} className="btn btn-primary float-right ">{LBL_POST}</button>
                            </div>
                        </Row>

                        {(!crewNotesList || (Array.isArray(crewNotesList) && crewNotesList.length===0) && notesLoaded) && 
                        <Row>
                            <div className='col-md-12 small'>&nbsp;</div>
                            <div className='col-md-12 padding-right-30'>
                                <div className='col-md-12 small center-align padding-Bottom-5'>{MSG_NOT_FOUND}</div>
                            </div>
                        </Row>}
                        
                        { crewNotesList && Array.isArray(crewNotesList) && crewNotesList.map((item)  => {
                            let note_posted_on = converDateToLocal(item.created_on,timeZone.utc_offset,'ddmmyyyyhhmm'); 

                            return (<div className='padding-top-5'><Row >
                                <div className='col-md-5 small padding-Bottom-5 padding-left-0'><small>{item.user_by_name}</small></div>
                                <div className='col-md-4 small right-align padding-Bottom-5'><small>{note_posted_on}</small></div>
                                <div className="col-md-3 small padding-Bottom-5">&nbsp;</div>
                            </Row>
                            <Row className="box-content">
                                <div className='col-md-9 small padding-left-0'>
                                    <div className=''>{item.notes}</div>
                                </div>
                                <div className="col-md-3 small">
                                    { item.crewnotedoc_set && item.crewnotedoc_set.length > 0 && 
                                    item.crewnotedoc_set.map(el => {
                                        if(el.file) { 
                                            let ext = el.file.substr(el.file.lastIndexOf('.') + 1); 
                                            return (
                                            <div className="file-icon padding-right-5" key={el.id}>
                                                <a href={el.file} target="_blank" rel="noopener noreferrer" style={{display:"inline"}}>
                                                <FileIcon extension={ext} fold={true} 
                                                radius={3} color="whitesmoke" {...defaultStyles[ext]}/>
                                                </a>
                                                {!isSuperAdmin && <span className=" remove-file" onClick=
                                                {(e)=>this.delNotesDocFile(e,item.id,el.id)}> <i className="las la-minus"></i></span>}
                                            </div>
                                            )
                                        }
                                        else {
                                            return(
                                                <div>&nbsp;</div>
                                            )
                                        }
                                    })
                                    }

                                    {item.crewnotedoc_set && item.crewnotedoc_set.length < 4 && <> <label htmlFor={item.id}>
                                            <i className="las la-plus add-file" ></i>
                                        </label>
                                        <input type="file" id={item.id} name="docFile" onChange={(e) => this.onHandleChange(e,item.id)} accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.xlsx,.xls" />
                                    </>}
                                </div>
                                
                            </Row>
                            <hr className='hr-style'></hr>
                            </div>)
                            })
                        } 

                        {totalPages > 0 && currentPage > 0 && totalPages > currentPage && 
                        <Row>
                            <div className='col-md-12 padding-right-30 padding-top-35'>
                                <div className='col-md-12 small center-align padding-Bottom-5'><Link to="#" onClick={this.loadNextPage} >{LBL_VIEW_MORE}</Link></div>
                            </div>
                        </Row>} 


                        
                    </Form.Group>
                </Form>
                <div className="padding-top-50">&nbsp;</div>
                <div className="padding-top-50">&nbsp;</div>
                </div>

                {/* <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {LBL_CONFIRM_DELETE_DOCUMENT+" '"+this.state.docName+"'?"}
                </ModalWindow> */}
                <ModalWindow ref={this.modalFileDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.deleteNotesDocFile} resetModalForm={this.onModalFormReset} >
                    {LBL_CONFIRM_DELETE_NOTES_DOCUMENT}
                </ModalWindow>
                <div className="row">&nbsp;</div>
                <div className="row">&nbsp;</div>
                <div className="row">&nbsp;</div>
                <div className="row">&nbsp;</div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    // console.log('state.crews.crewNotesResLinks:',JSON.stringify(state.crews.crewNotesResLinks)); 
    return {
        crewNotesList:state.crews.crewNotesList,
        status:state.crews.status,
        crewNotesActivity:state.crews.crewNotesActivity, 
        errorData:state.crews.errorData,
        totalPages:state.crews.crewNotesTotalPages, 
        numRows:state.crews.numRows, 
        count:state.crews.count, 
        crewNotesResLinks:state.crews.crewNotesResLinks,
        crewNotesNew:state.crews.crewNotesNew,
        crewNotesDocNew:state.crews.crewNotesDocNew, 
        crewNotesDocDeleted:state.crews.crewNotesDocDeleted,
    }
}                   

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        crewNotesListAction:crewNotesListAction,
        crewNotesAddAction:data=>crewNotesAddAction(data),
        crewNotesDocumentAddAction:crewNotesDocumentAddAction,
        crewNotesDocumentDeleteAction:crewNotesDocumentDeleteAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(CrewNotes);
